import * as XLSX from 'xlsx-js-style';

export const FETCH_CHUNK = 100;

/** Shared neutral palette for printable report tables (HTML + Excel). */
export const REPORT_TABLE_HEADER_BG = '#f9fafb';
export const REPORT_TABLE_HEADER_TEXT = '#111827';
export const REPORT_TABLE_HEADER_BORDER = '#d1d5db';
export const REPORT_TABLE_HEADER_FILL_RGB = 'F9FAFB';
export const REPORT_TABLE_HEADER_TEXT_RGB = '111827';
export const REPORT_TABLE_HEADER_BORDER_RGB = 'D1D5DB';
export const REPORT_PRINT_GROUP_BANNER_BG = '#f3f4f6';
export const REPORT_PRINT_GROUP_FOOTER_BG = '#f9fafb';
export const REPORT_PRINT_ACCENT_BORDER = '#d1d5db';

export function applyExcelHeaderRowStyle(ws) {
  if (!ws || !ws['!ref']) return;
  const range = XLSX.utils.decode_range(ws['!ref']);
  const r0 = range.s.r;
  for (let c = range.s.c; c <= range.e.c; c += 1) {
    const addr = XLSX.utils.encode_cell({ r: r0, c });
    const cell = ws[addr];
    if (!cell) continue;
    cell.s = {
      font: { bold: true, color: { rgb: REPORT_TABLE_HEADER_TEXT_RGB } },
      fill: { patternType: 'solid', fgColor: { rgb: REPORT_TABLE_HEADER_FILL_RGB } },
      alignment: { vertical: 'center', horizontal: 'center', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
        bottom: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
        left: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
        right: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
      },
    };
  }
}

/**
 * Opens print dialog in the same tab using a hidden iframe (no new browser tab).
 * HTML must not call window.print() itself.
 */
export function printHtmlInSameTab(htmlDocumentString, iframeTitle = 'Print') {
  return new Promise((resolve, reject) => {
    let iframe;
    let settled = false;
    const finish = (err) => {
      if (settled) return;
      settled = true;
      removeIframe();
      if (err) reject(err);
      else resolve();
    };
    const removeIframe = () => {
      try {
        if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      } catch {
        /* ignore */
      }
    };

    try {
      iframe = document.createElement('iframe');
      iframe.setAttribute('title', iframeTitle);
      Object.assign(iframe.style, {
        position: 'fixed',
        right: '0',
        bottom: '0',
        width: '0',
        height: '0',
        border: '0',
        visibility: 'hidden',
      });

      let printStarted = false;
      const runPrint = () => {
        if (settled || printStarted) return;
        printStarted = true;
        const win = iframe.contentWindow;
        if (!win) {
          finish(new Error('Print frame not available'));
          return;
        }
        // Large reports need a moment after parse before layout is ready for print.
        const delayMs = htmlDocumentString.length > 250000 ? 600 : htmlDocumentString.length > 80000 ? 350 : 150;
        setTimeout(() => {
          try {
            win.focus();
            win.print();
          } catch (e) {
            finish(e);
            return;
          }
          setTimeout(() => finish(), 400);
        }, delayMs);
      };

      iframe.onload = () => runPrint();
      iframe.onerror = () => finish(new Error('Failed to load print document'));

      document.body.appendChild(iframe);
      iframe.srcdoc = htmlDocumentString;

      // Fallback if onload does not fire (some browsers with very large srcdoc).
      setTimeout(() => runPrint(), 3000);
    } catch (e) {
      finish(e);
    }
  });
}
